<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <svg
    class="expensa-kind-icon"
    viewBox="0 0 24 24"
    width="22"
    height="22"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <template v-if="kind === 'MILEAGE'">
      <path d="M3 15l2-6h14l2 6v4h-3v-2H6v2H3z" />
      <circle cx="7.5" cy="14" r="1" />
      <circle cx="16.5" cy="14" r="1" />
    </template>
    <template v-else-if="kind === 'PER_DIEM'">
      <rect x="3" y="8" width="18" height="12" rx="2" />
      <path d="M9 8V5h6v3M3 13h18" />
    </template>
    <template v-else>
      <path d="M6 3h12v18l-3-2-3 2-3-2-3 2z" />
      <path d="M9 8h6M9 12h6" />
    </template>
  </svg>
</template>

<script>
// Icona del tipo di spesa: l'elenco non ha URL delle miniature.
export default {
  name: 'ExpensaKindIcon',
  props: {
    kind: {
      type: String,
      default: 'RECEIPT',
    },
  },
};
</script>

<style scoped lang="scss">
.expensa-kind-icon {
  color: #64728c;
  vertical-align: middle;
}
</style>
